// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"f89e51b5","462":"5600190c","594":"6516d927","777":"9ea0adc7","793":"18e2321b"}[chunkId] + ".chunk.js";
};